import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { sortBy } from 'lodash';

@Component({
  standalone: false,
  selector: 'app-formly-field-select',
  templateUrl: './formly-field-select.component.html',
  styleUrls: ['./formly-field-select.component.scss']
})
export class FormlyFieldSelectComponent extends FieldType implements OnInit
{
  public usesCodeSet = false;
  public dictionaryData: any[] = [];
  public textField = 'label';
  public valueField = 'value';

  constructor(
    private dictionaryService: DictionaryService,
    private messageHandlerService: MessageHandlerService)
  {
    super();
  }

  public ngOnInit(): void
  {
    if (this.field?.templateOptions?.codeSetId)
    {
      this.usesCodeSet = true;
      this.textField = 'displayName';
      this.valueField = 'code';
      this.dictionaryService.getCachedCodesByCodeSetId(this.field.templateOptions.codeSetId).subscribe({
        next: (data) =>
        {
          this.dictionaryData = sortBy(data, ['displayName']);
          this.syncComboboxValue();
        },
        error: (error) =>
        {
          this.messageHandlerService.displayError(error);
        }
      });
    }
    else
    {
      setTimeout(() => this.syncComboboxValue());
    }
  }

  private syncComboboxValue(): void
  {
    const value = this.formControl?.value;
    if (value !== undefined && value !== null && value !== '')
    {
      this.formControl.setValue(value, { emitEvent: false });
      this.formControl.updateValueAndValidity({ emitEvent: false });
    }
  }
}
